import { IJourneySchema } from "../../../../types/journeyInput.types";

export const advisedAnnuityJourney: IJourneySchema = {
  journeyId: "advised-annuity",
  journeyName: "Advised Annuity",
  description:
    "Secure guaranteed income for life with personalized IFA advice.",
  tagLine: "whole of market quotes",
  available: true,
  basePriority: 10,
  priorityRules: [
    {
      fact: "clientFirstIntent",
      operator: "equal",
      value: "advised-annuity-calculator",
      boost: 50,
    },
    {
      fact: "latestMilestoneId",
      params: { ids: ["100299", "100019", "100300"] },
      operator: "equal",
      value: "100299", // an annual review is currently active
      boost: -1000,
    },
  ],
  tools: [
    {
      toolId: "annuity-quotes-quick",
      completionOrder: 1,
      isRequired: true,
      visibleWhen: {
        all: [
          {
            fact: "milestoneCompleted",
            params: { id: "100225" },
            operator: "notEqual",
            value: true,
          },
          {
            fact: "milestoneCompleted",
            params: { id: "100013" },
            operator: "notEqual",
            value: true,
          },
        ],
      },
    },
    {
      toolId: "loa-pension-review",
      completionOrder: 2,
      isRequired: false,
      visibleWhen: {
        any: [
          {
            fact: "milestoneCompleted",
            params: { id: "100233" },
            operator: "notEqual",
            value: false,
          },
          {
            fact: "milestoneCompleted",
            params: { id: "100139" },
            operator: "notEqual",
            value: false,
          },
          {
            fact: "hasPensions",
            operator: "equal",
            value: true,
          },
        ],
      },
    },
    {
      toolId: "annuity-quotes-full",
      completionOrder: 3,
      isRequired: true,
    },
    { toolId: "ifa-call-booking", completionOrder: 4, isRequired: true },
    {
      toolId: "fact-find",
      completionOrder: 5,
      isRequired: true,
    },
    { toolId: "application", completionOrder: 6, isRequired: true },
    {
      toolId: "annual-review-summary",
      completionOrder: 7,
      isRequired: false,
      visibleWhen: {
        any: [
          {
            fact: "milestoneCompleted",
            params: { id: "100019" }, // Annual review complete
            operator: "equal",
            value: true,
          },
          {
            fact: "milestoneCompleted",
            params: { id: "100300" }, // Annual review cancelled (not proceeding outcome)
            operator: "equal",
            value: true,
          },
        ],
      },
    },
  ],
};
